import { browserSearch } from './tool/browser-search';

export const groqTools = {
  browserSearch,
};
